import React, { CSSProperties } from "react";
import { Typography, TypographyProps } from "@mui/material";
import IconComponent from "./IconComponent";

interface Props extends TypographyProps  {
  value: string | number | string[];
  halfOpacity?: boolean;
  fontSize?: number;
  style?: CSSProperties;
  color?: string;
  children?: React.ReactElement;
}

const AdronTypography = ({
  value,
  halfOpacity,
  fontSize,
  style,
  color,
  children,
  ...props
}: Props) => {
  return (
    <Typography
      {...props}
      sx={{
        textTransform: "none",
        opacity: halfOpacity ? 0.5 : 1,
        fontSize: fontSize ? `${fontSize}px` : "14px",
        ...style,
      }}
      variant="body2"
      color={color ? color : "textSecondary"}
    >
      {value}
      {children}
    </Typography>
  );
};

export default AdronTypography;
